export const hasMatchingParent = (
	el: HTMLElement,
	selector: string
): boolean =>
	el.parentElement
		? el.parentElement.matches( selector ) ||
		  hasMatchingParent( el.parentElement, selector )
		: false;

export const getParent = (
	el: HTMLElement,
	selector: string
): HTMLElement | null => {
	if ( ! el.parentElement ) {
		return null;
	}
	if ( el.parentElement.matches( selector ) ) {
		return el.parentElement;
	}
	return getParent( el.parentElement, selector );
};

export const hasDistantRelativeWithSameAncestor = (
	el: HTMLElement,
	ancestorSelector: string,
	relativeSelector: string
): boolean => {
	const parent = getParent( el, ancestorSelector );
	if ( ! parent ) {
		return false;
	}

	const distantSiblings = parent.querySelectorAll( relativeSelector );
	return distantSiblings.length > 0;
};

export const getPageSection = ( el: HTMLElement ) => {
	if (
		hasMatchingParent(
			el,
			[
				'.dhsv-header-sticky-list, .dhsv-header-sticky-list-mobile', // hs-fresenius
				'header.sticky-header div.nav-burger', // charlotte-fresenius-uni
				'.mobile-header-container', // carl-remigius
			].join( ', ' )
		)
	) {
		return 'floating';
	} else if (
		hasMatchingParent(
			el,
			[
				'header .top-nav', // hs-fresenius
			].join( ', ' )
		)
	) {
		return 'top navigation';
	} else if ( hasMatchingParent( el, 'header' ) ) {
		return 'header section';
	} else if (
		hasMatchingParent(
			el,
			[
				'.dhsv-home-stage-block', // hs-fresenius
				'.dhsv-stage-detail', // hs-fresenius
				'.dhsv_vc_stage', // not sure where this is still used
				'.dhsv_stage_new', // amdnet
				'.amd-home-stage', // amdnet
			].join( ', ' )
		)
	) {
		return 'top section';
	} else if ( hasMatchingParent( el, 'footer' ) ) {
		return 'footer';
	} else if (
		hasMatchingParent(
			el,
			[
				'main > div.is-root-container', // hs-fresenius
				'#root', // amdnet
				'#dhsv-page-wrap', // charlotte-fresenius-uni, carl-remigius
			].join( ', ' )
		)
	) {
		return 'mid section';
	}

	return 'other';
};

export const isMehrErfahrenLink = ( el: HTMLElement ) => {
	const text = ( el.textContent || el.innerText ).trim();
	return /^mehr (erfahren|info|anzeigen)/i.test( text );
};
